import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import {
  View, ViewStyle, StyleSheet,
} from 'react-native';
import Animated, {
  Easing,
  useAnimatedStyle, useSharedValue, withDelay, withRepeat, withTiming,
} from 'react-native-reanimated';
import Colors from '../constants/Colors';
import isMobile from './IsMobile';

const BASE_COLORS = {
  dark: { primary: '#ffffff70', secondary: '#ffffff70' },
} as const;

const makeColors = (mode: keyof typeof BASE_COLORS) => [
  'transparent',
  BASE_COLORS[mode].primary,
  BASE_COLORS[mode].secondary,
  'transparent',
];

const SkeletonLoader = ({
  style,
  delay,
  height = 80,
}: {
  style?: ViewStyle;
  delay?: number;
  height?: number;
} = {}) => {
  // console.log('render: ' + new Date().toISOString())
  const translateX = useSharedValue(-250);
  const [width, setWidth] = React.useState(150);

  const colors = makeColors('dark');
  // console.log(colors);
  const targetRef = React.useRef<View>(null);

  const onLayout = React.useCallback(() => {
    targetRef.current?.measure((_x, _y, newWidth) => {
      if (newWidth) {
        setWidth(newWidth);
      }
    });
  }, []);

  React.useEffect(() => {
    translateX.value = withRepeat(
      withDelay(
        delay,
        withTiming(width * 2, {
          duration: 1500,
          easing: Easing.linear,
        }),
      ),
      -1,
      false,
    );
  }, [width]);

  const translateXStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }));

  return (
    <View
      ref={targetRef}
      style={[
        {
          height,
          borderRadius: 8,
          marginBottom: 8,
          overflow: 'hidden',
          backgroundColor: Colors.light.hereworksWhite400,
        },
        style,
      ]}
      onLayout={onLayout}
    >
      <Animated.View
        style={[
          {
            width,
            height,
          },
          translateXStyle,
        ]}
      >
        <LinearGradient
          colors={colors}
          style={[StyleSheet.absoluteFill,
            { opacity: isMobile ? 0.3 : 1 }]} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}
          locations={[0, 0.4, 0.6, 1]} />
      </Animated.View>
    </View>
  );
};

export default SkeletonLoader;
